import {AppConstants, AppRoutes, Notification} from './global';
import {SnotifyService} from 'ng-snotify';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {MatDialog, MatSnackBar} from '@angular/material';
import { Subscription } from 'rxjs';
import {SnotifyType} from 'ng-snotify/snotify/types/snotify.type';
import {Dataset, Folder, Transform} from '4d-mapper';
import {AppDialog} from './dialogs/app-dialog';
import {Observable} from 'rxjs';
import {DZIDialog, MapDialog} from './dialogs/map-dialog';
import {MapDialogPlotAll} from './dialogs/map-dialog-plot-all';
import {FourDInjector} from './FourDInjector';
import {Constants} from './Constants';
import {EpsgcodeDialog} from './dialogs/epsgcode/epsgcode-dialog.component';
import { OnInit, OnDestroy } from '@angular/core';
import { XsIdentityInterface } from '../xs/interfaces/identify.interface';
import { XsEventListenerInterface } from '../xs/interfaces/event-listener.interface';
import { PluginManagerService } from '../service/plugin-manager.service';


const Cesium = (<any>window).Cesium;


/* 
    BaseComponent
    -------------
    Meant to be the core component, not DI, so mostly technical stuff that doesn't use any other components or helpers.
    It's also the base, base, base component, so all components, not just the annotation stuff, uses this one.

  */

export class BaseComponent implements XsIdentityInterface, XsEventListenerInterface, OnInit, OnDestroy {

  debug:boolean = Constants.debug_off;
  debugMe:string = null;
  debugPrimary:string = Constants._gray;
  debugSecondary:string = Constants._white;

  debugBase:boolean = false;

  __ID      = null;
  __EVENTS  = null;

  loading: boolean = false
  routes = AppRoutes

  _subs:Subscription[] = [];

  appConstants = AppConstants

  snotifyService: SnotifyService ; //= AppModule.injector.get(SnotifyService)
  translate: TranslateService ; //= AppModule.injector.get(TranslateService)

  pluginManager:any = null;

  // our mouse handler
  mouseHandler:any = null;

  // the cursor for creating a new annotation
  mouseCursor:any = null;

  // current interaction mode (for whatever component is in control)
  interactionMode:string = 'select';

  // a flag for whether we're currently dragging somerthing around
  isDragging = false;


  // any shapes inside this annotation
  shapes:any = [];

  // plugins
  plugin:any = null;

  // a handy helper-class for state and ghosts (artefacts for drawing, like handles and dotted lines)
  shapeMaker:any = null;

  // calculating variables
  
  // how far have we come?
  public percentFinished:number = 0;

  // can this component calculate anything? (area, volume, etc.)
  public canCalculate = false;
  public canCalculateVolume = false;
  public autoCalculate = false;

  public calculating:boolean = false;
  protected currentCalc:number = 0;
  protected totalCalc:number = 1;


  // key events
  protected boundKeyboardDown: any
  protected boundKeyboardUp: any

  // key masks
  masks = {}


  checkMobileCounter:number = 9999;
  currentSize:number = 0;


  constructor(public router: Router, public snackBar: MatSnackBar, public dialog: MatDialog ) {
    
    this.debugMe = this.constructor.name;
    if ( this.debugBase ) { console.log ( '%c base.comp ['+this.debugMe+'] %c constructor', Constants._green, Constants._black ); }

    this.snotifyService = FourDInjector.injector.get(SnotifyService);
    this.translate =  FourDInjector.injector.get(TranslateService);
    this.pluginManager =  FourDInjector.injector.get(PluginManagerService);

    // if ( this.debug ) { console.log ( '%c base.comp ['+this.debugMe+'] %c constructor END', Constants._yellow, Constants._yellow, this.snotifyService, this.translate ); }
  }

  _buggy ( id, msg = null, ...args ) {
    if ( this.debug ) { console.log ( '%c ['+this.debugMe+'] %c '+id+'()'+(msg?' / '+msg:''), this.debugPrimary, this.debugSecondary, ...args ); }
  }

  // this components various subscriptions to events
  addSubscription ( id:string, f:any ) {
    if ( this.debugBase ) { console.log ( '%c base.comp ['+this.debugMe+'] %c addSubscription('+id+')', Constants._yellow, Constants._yellow, f ); }
    this._subs.push(f);
  }

  // delete all of them
  deleteSubscriptions() {
    if ( this.debugBase ) { console.log ( '%c base.comp ['+this.debugMe+'] %c deleteSubscriptions()', Constants._green, Constants._black, this._subs.length ); }
    this._subs.forEach(sub => sub.unsubscribe());
  }

  __xs_start() {
    this.__ID      = XsIdentityInterface.__init(this);
    this.__EVENTS  = XsEventListenerInterface.__init(this);
    if ( this.debugBase ) { console.log ( '%c base.comp ['+this.debugMe+'] %c __xs_start()', Constants._green, Constants._black, this.__ID.instance ); }
  }

  __xs_end() {
    if ( this.debugBase ) { console.log ( '%c base.comp ['+this.debugMe+'] %c __xs_end()', Constants._green, Constants._black ); }
    XsEventListenerInterface.__destroy(this);
  }

  ngOnInit() {
    if ( this.debugBase ) { console.log ( '%c base.comp ['+this.debugMe+'] %c ngOnInit()', Constants._green, Constants._black ); }

    // set up unique identifiers and event handlers
    this.__xs_start();

    // finally init (overridable)
    this.init();

  }
  init() {
    if ( this.debugBase ) { console.log ( '%c base.comp ['+this.debugMe+'] %c init()', Constants._green, Constants._black ); }
  }

  // default destroyer just calls the deleteSubscriptions. If you provide your own, 
  // remember to call deleteSubscriptions() yourself or call super
  ngOnDestroy() {
    if ( this.debugBase ) { console.log ( '%c base.comp ['+this.debugMe+'] %c ngOnDestroy()', Constants._green, Constants._black ); }
    this.deleteSubscriptions();
    this.destroy();
    this.__xs_end();
  }
  destroy() {
    if ( this.debugBase ) { console.log ( '%c base.comp ['+this.debugMe+'] %c destroy()', Constants._green, Constants._black ); }
  }

  // method for components to override if they've got calculations
  calculate() { }

  keyUp(e: KeyboardEvent) {
    delete this.masks[e.keyCode]
    if (e.keyCode == 17 || e.keyCode == 224 || e.keyCode == 91) {
      delete this.masks['ctrl']
    }
    if (e.keyCode == 18) {
      delete this.masks['alt']
    }
    if (e.keyCode == 16) {
      delete this.masks['shift']
    }
  }

  keyDown(e: KeyboardEvent) {

    // delete or backspace
    if (e.keyCode == 46 || e.keyCode == 110 || e.keyCode == 8) {

    } else if ((e.ctrlKey || e.metaKey) && e.keyCode == 17 || e.keyCode == 224 || e.keyCode == 91) {
      this.masks['ctrl'] = e.keyCode
    } else if (e.altKey && e.keyCode == 18) {
      this.masks['alt'] = e.keyCode
    } else if (e.shiftKey && e.keyCode == 16) {
      this.masks['shift'] = e.keyCode
    } else if (e.shiftKey && e.keyCode == 16) {
      this.masks['shift'] = e.keyCode
    } else {
      this.masks[e.keyCode] = true
    }
  }





  private openSnackBar(message: string, action: string = '', type?: string, meta?: any) {
    if (message == null) message = ''
    if (action == null) action = ''
    this.translate.get([message, action, 'DIALOG.SUCCESS', 'DIALOG.INFO', 'DIALOG.WARNING', 'DIALOG.ERROR'], meta)
      .subscribe(param => {
        let successTitle = param['DIALOG.SUCCESS']
        let infoTitle = param['DIALOG.INFO']
        let warningTitle = param['DIALOG.WARNING']
        let errorTitle = param['DIALOG.ERROR']
        if (message) message = param[message]
        if (action) action = param[action]

        if (this.isMobile()) {
          return this.snackBar.open(message, action, {
            duration: Constants.SNACKBAR_DURATION,
            panelClass: type ? type : ''
          })
        } else if (action) {
          this.snotifyService.confirm(message, {
            showProgressBar: false,
            closeOnClick: false,
            type: this.getSnotifyType(type),
            buttons: [
              {
                text: action, action: (toast) => {
                  this.snotifyService.remove(toast.id);
                }, bold: true
              }
            ]
          })
        } else if (type == Notification.INFO) {
          this.snotifyService.info(message, infoTitle)
        } else if (type == Notification.SUCCESS) {
          this.snotifyService.success(message, successTitle)
        } else if (type == Notification.WARN) {
          this.snotifyService.warning(message, warningTitle)
        } else if (type == Notification.ERROR) {
          this.snotifyService.error(message, errorTitle)
        } else {
          this.snotifyService.simple(message)
        }

      })

  }
  getSnotifyType(type: string): SnotifyType {
    if (type == Notification.INFO) return 'info'
    else if (type == Notification.SUCCESS) return 'success'
    else if (type == Notification.ERROR) return 'error'
    else if (type == Notification.WARN) return 'warning'
    else return 'simple'
  }

  openSnackBarInfo(message: string, action?: string, meta?: any) {
    return this.openSnackBar(message, action, Notification.INFO, meta)
  }

  openSnackBarSuccess(message: string, action?: string, meta?: any) {
    return this.openSnackBar(message, action, Notification.SUCCESS, meta)
  }

  openSnackBarError(message: string, action?: string, meta?: any) {
    return this.openSnackBar(message, action, Notification.ERROR, meta)
  }

  openSnackBarWarn(message: string, action?: string, meta?: any) {
    return this.openSnackBar(message, action, Notification.WARN, meta)
  }

  openDialog(title: string, desc?: string, posBtn?: string, negBtn?: string, input?: any,isExternalURL?: boolean, error?: { status, message }): Observable<any> {

    // var d = {title: title, text: desc, posBtn: posBtn, negBtn: negBtn, input: input, isExternalURL: isExternalURL, error: error } ;
    // console.log ( '!!!!!!!!!!!!!!!! incoming !!!!!!!!!!!!!!!!!!!', d ) ;

    let dialogRef = this.dialog.open ( AppDialog, {
      width: '350px',
      data: {title: title, text: desc, posBtn: posBtn, negBtn: negBtn, input: input, isExternalURL: isExternalURL, error: error }
    });

    return dialogRef.afterClosed()
  }

  openEPSGDialogWith(title: string, desc?: string, posBtn?: string, negBtn?: string): Observable<any> {

    let dialogRef = this.dialog.open(EpsgcodeDialog, {
      width: '65%',
      height: '86%', 
      data: {title: title, text: desc, posBtn: posBtn, negBtn: negBtn}
    });

    return dialogRef.afterClosed()
  }

  openMapDialogWithItems(ds: Dataset, items: Transform[], title: string, desc?: string, posBtn?: string, negBtn?: string): Observable<any> {

    let dialogRef = this.dialog.open(MapDialog, {
      width: '80%',
      height: '80%',
      data: {title: title, text: desc, posBtn: posBtn, negBtn: negBtn, items: items, dataset: ds}
    });

    return dialogRef.afterClosed()
  }

  openConfirmDelete(cb:Function,name:string){
    this.openDialogWithMeta({deletename: name}, 'GENERIC.DIALOG.DELETE.TITLE', 'GENERIC.DIALOG.DELETE.MSG', 'GENERIC.YES', 'GENERIC.NO').subscribe(s => {
      if(s)
        cb()
    })

  }

  openMapDialogPlotAllWithItems(ds: Dataset, items: Transform[], title: string, selectedFolder?: Folder, desc?: string, posBtn?: string, negBtn?: string): Observable<any> {

    let dialogRef = this.dialog.open(MapDialogPlotAll, {
      width: '80%',
      height: '80%',
      data: {
        title: title,
        text: desc,
        posBtn: posBtn,
        negBtn: negBtn,
        items: items,
        dataset: ds,
        selectedFolder: selectedFolder
      }
    });

    return dialogRef.afterClosed()
  }

  openDZIDialogWith(img: Transform, title: string, desc?: string, posBtn?: string, negBtn?: string): Observable<any> {

    let dialogRef = this.dialog.open(DZIDialog, {
      width: '65%',
      height: '85%',
      data: {title: title, text: desc, posBtn: posBtn, negBtn: negBtn, img: img}
    });

    return dialogRef.afterClosed()
  }
  openEdgeWarningDialog(){
    if(window.navigator.userAgent.indexOf("MSIE") > -1 || window.navigator.userAgent.indexOf("Trident") > -1 || window.navigator.userAgent.indexOf("Edge") > -1)
      this.openDialog('GENERIC.SWITCH_BROWSER').subscribe();
  }



  /*openMetadataDialogWith(title: string, desc?: string, posBtn?: string, negBtn?: string): Observable<any> {

    let dialogRef = this.dialog.open(MetadataDialogComponent, {
      width: '65%',
      height: '80%',
      data: {title: title, text: desc, posBtn: posBtn, negBtn: negBtn}
    });

    return dialogRef.afterClosed()
  }*/


  openDialogWithMode(mode: string, title: string, desc?: string, posBtn?: string, negBtn?: string, input?: any, width?: string, error?: { status, message }): Observable<any> {

    let dialogRef = this.dialog.open(AppDialog, {
      width: width ? width : '80%',
      data: {title: title, text: desc, posBtn: posBtn, negBtn: negBtn, input: input, error: error, mode: mode}
    });

    return dialogRef.afterClosed()
  }



  openDialogWithModeAndFilter(mode: string, filter: any, title: string, desc?: string, posBtn?: string, negBtn?: string, input?: any, error?: { status, message }): Observable<any> {

    let dialogRef = this.dialog.open(AppDialog, {
      width: '80%',
      data: {
        title: title,
        text: desc,
        posBtn: posBtn,
        negBtn: negBtn,
        input: input,
        error: error,
        mode: mode,
        filter: filter
      }
    });

    return dialogRef.afterClosed()
  }

  openDialogWithModeAndFilterAndMeta(meta: any, mode: string, filter: any, title: string, desc?: string, posBtn?: string, negBtn?: string, input?: any, error?: { status, message }): Observable<any> {

    let dialogRef = this.dialog.open(AppDialog, {
      width: '80%',
      data: {
        meta: meta,
        title: title,
        text: desc,
        posBtn: posBtn,
        negBtn: negBtn,
        input: input,
        error: error,
        mode: mode,
        filter: filter
      }
    });

    return dialogRef.afterClosed()
  }

  openDialogWithMeta(meta: any, title: string, desc?: string, posBtn?: string, negBtn?: string, input?: any, error?: { status, message }): Observable<any> {

    let dialogRef = this.dialog.open(AppDialog, {
      width: '350px',
      data: {title: title, text: desc, posBtn: posBtn, negBtn: negBtn, input: input, error: error, meta: meta}
    });

    return dialogRef.afterClosed()
  }

/*
  replace(value: string, params: Array<string>): string {
    params.forEach((element, index) => {
      value = value.replace('$%' + (index + 1), element)
    });
    return value
  }
*/


// navigation

  navigateToRoute (route: string) {
    if ( this.debug ) { console.log ( '%c base.comp ['+this.debugMe+'] %c navigateToRoute()', this.debugPrimary, this.debugSecondary, route ); }
    this.router.navigateByUrl(route)
  }

  //navigate back to previous location
  navigateBack(location) {
    if ( this.debug ) { console.log ( '%c base.comp ['+this.debugMe+'] %c navigateBack()', this.debugPrimary, this.debugSecondary ); }
    location.back();
  }

  goBack() {
    if ( this.debug ) { console.log ( '%c base.comp ['+this.debugMe+'] %c goBack()', this.debugPrimary, this.debugSecondary ); }
    window.history.back()
  }

  cancel() {
    if ( this.debug ) { console.log ( '%c base.comp ['+this.debugMe+'] %c cancel()', this.debugPrimary, this.debugSecondary ); }
    this.goBack();
  }

  /**
   * Returns true if the screen is mobile size
   */
  isMobile() {
    return this.checkWindowSize() < 770;
  }
  isMobileSmall() {
    return this.currentSize < 500;
  }
  isMobileLarge() {
    return this.currentSize < 1025;
  }
  
  checkWindowSize() {
    if ( this.checkMobileCounter++ > 150 ) {
      this.checkMobileCounter = 0;
      this.currentSize = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
    return this.currentSize;
  }



}

